const ALLOWED_TAGS = new Set(['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'a']);
const DROP_CONTENT = new Set([
  'script', 'style', 'iframe', 'object', 'embed', 'svg', 'math', 'template',
  'form', 'input', 'textarea', 'select', 'button', 'video', 'audio', 'picture',
]);
const BLOCK_TAGS = new Set(['p', 'br', 'ul', 'ol', 'li']);

export const MAX_SUCCESS_VISIBLE_CHARACTERS = 4000;
export const MAX_SUCCESS_HTML_CHARACTERS = 16000;

function fragment(html) {
  // Template contents are inert: pasted media and executable markup never enter the live DOM.
  const template = document.createElement('template');
  template.innerHTML = html || '';
  return template.content;
}

export function successMessageVisibleText(html) {
  const text = (node) => {
    if (node.nodeType === Node.TEXT_NODE) return node.textContent;
    const children = Array.from(node.childNodes).map(text).join('');
    return BLOCK_TAGS.has(node.nodeName.toLowerCase()) ? ` ${children} ` : children;
  };
  return text(fragment(html)).replace(/[\s\u00a0]+/g, ' ').trim();
}

export function sanitizeBusinessActionSuccessHtml(html, preserveEditingStructure = false) {
  const output = document.createElement('div');
  const copy = (node, parent) => {
    if (node.nodeType === Node.TEXT_NODE) {
      parent.appendChild(document.createTextNode(node.textContent));
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    // Browsers create divs on Enter in contenteditable. Keep those paragraph boundaries
    // while editing, but submit only the server's allowed p elements.
    const tag = preserveEditingStructure && node.localName === 'div' ? 'p' : node.localName;
    if (DROP_CONTENT.has(tag) || node.namespaceURI !== 'http://www.w3.org/1999/xhtml') return;
    let destination = parent;
    if (ALLOWED_TAGS.has(tag)) {
      destination = document.createElement(tag);
      if (tag === 'a') {
        const href = node.getAttribute('href') || '';
        // Do not resolve relative URLs or decode percent-encoded protocols into executable links.
        const hasControlOrSpace = Array.from(href).some((char) => char.charCodeAt(0) <= 32 || char.charCodeAt(0) === 127);
        if (/^https?:\/\//i.test(href) && !hasControlOrSpace) {
          try {
            const url = new URL(href);
            if (url.protocol === 'http:' || url.protocol === 'https:') destination.setAttribute('href', href);
          } catch (_error) { /* Invalid links retain only their label. */ }
        }
        if (node.hasAttribute('title')) destination.setAttribute('title', node.getAttribute('title'));
        destination.setAttribute('rel', 'noopener noreferrer');
        destination.setAttribute('target', '_blank');
      }
      parent.appendChild(destination);
    }
    Array.from(node.childNodes).forEach((child) => copy(child, destination));
  };
  Array.from(fragment(html).childNodes).forEach((node) => copy(node, output));
  return preserveEditingStructure || successMessageVisibleText(output.innerHTML) ? output.innerHTML : '';
}

export const sanitizeBusinessActionSuccessEditorHtml = (html) => sanitizeBusinessActionSuccessHtml(html, true);

export function successMessageLimitError(html) {
  if (html.length > MAX_SUCCESS_HTML_CHARACTERS) {
    return 'Keep the message HTML within 16000 characters (including formatting and links).';
  }
  if (successMessageVisibleText(html).length > MAX_SUCCESS_VISIBLE_CHARACTERS) {
    return 'Keep the message within 4000 visible characters.';
  }
  return '';
}
